import React from "react";

const IconPlay = props => (
  <svg
    viewBox="0 0 287 427"
    fillRule="evenodd"
    clipRule="evenodd"
    strokeLinejoin="round"
    strokeMiterlimit={1.414}
    {...props}
  >
    <g transform="matrix(1 0 0 .89707 -77.39 -42.884)">
      <path fill="none" d="M77.39 47.804h286.34v475.105H77.39z" />
      <clipPath id="a">
        <path d="M77.39 47.804h286.34v475.105H77.39z" />
      </clipPath>
      <g clipPath="url(#a)">
        <path d="M364.12 285.043L78.803 523.807 77.78 47.805l286.34 237.238z" />
      </g>
    </g>
  </svg>
);

export default IconPlay;
